import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import { UiService } from '@services/ui.service';
import { AdvancedComponent } from 'app/simulation/advanced/advanced.component';

@Injectable({
    providedIn: 'root'
})
export class PreventPartitionsChangesGuard implements CanDeactivate<AdvancedComponent> {
    constructor(
        private uiSrv: UiService
    ) { }

    canDeactivate(
        component: AdvancedComponent,
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

            if(component && component.isEdited) {
                return this.openDialog();
            }

            return true;
    }

    private openDialog(): Observable<boolean> | Promise<boolean> | boolean {
        const message = 'main.dialogs.confirmSimulation.summary';

        return this.uiSrv.confirmDialog(message)
        .afterClosed().pipe(
            take(1),
            tap((result: boolean) => {
                // if user send "Yes" continue navigation
                if(result) {
                    return true;
                }

                return false;
            })
        );
    }
}
